import { useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import ScheduleIcon from '@mui/icons-material/Schedule';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import RenewSubscriptionModal from './RenewSubscriptionModal';

export default function SubscriptionStatusPanel({
  status,
  daysLeft = 0,
  expiresAtLabel,
  appName,
  appKey,
  message,
}) {
  const [open, setOpen] = useState(false);
  const isExpired = status === 'EXPIRED' || status === 'EXPIRED_SOFT' || status === 'EXPIRED_HARD';
  const isStoreExpired = status === 'STORE_EXPIRED';

  let title = 'Suscripción requerida';
  let description = message || `Activa tu suscripción para usar ${appName}.`;

  if (isExpired) {
    title = 'Tu suscripción venció';
    description = expiresAtLabel
      ? `Tu suscripción de ${appName} venció el ${expiresAtLabel}. Renueva para volver a usar la aplicación.`
      : `Tu suscripción de ${appName} venció. Renueva para volver a usar la aplicación.`;
  } else if (status === 'EXPIRING') {
    title = 'Tu suscripción está por vencer';
    description = expiresAtLabel
      ? `Quedan ${daysLeft} día${daysLeft === 1 ? '' : 's'} de acceso. La suscripción vence el ${expiresAtLabel}.`
      : `Quedan ${daysLeft} día${daysLeft === 1 ? '' : 's'} de acceso.`;
  } else if (isStoreExpired) {
    title = 'Tienda sin suscripción activa';
    description =
      message ||
      'La suscripción de esta tienda ha vencido. Contacta al administrador para renovar el acceso.';
  }

  const Icon = isExpired || isStoreExpired ? EventBusyIcon : status === 'EXPIRING' ? ScheduleIcon : LockOpenIcon;
  const color = isExpired || isStoreExpired ? 'error' : status === 'EXPIRING' ? 'warning' : 'warning';

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Card
        variant="outlined"
        sx={{
          textAlign: 'center',
          py: 4,
          px: 3,
          borderColor: `${color}.light`,
          bgcolor: `${color}.50`,
        }}
      >
        <CardContent>
          <Icon color={color} sx={{ fontSize: 56, mb: 2 }} />
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {title}
          </Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 520, mx: 'auto', mb: 3 }}>
            {description}
          </Typography>

          {!isStoreExpired && (
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                variant="contained"
                size="large"
                onClick={() => setOpen(true)}
                sx={{ fontWeight: 'bold', px: 4 }}
              >
                {isExpired ? 'Renovar suscripción' : 'Activar suscripción'}
              </Button>
            </Stack>
          )}
        </CardContent>
      </Card>

      {!isStoreExpired && (
        <RenewSubscriptionModal
          open={open}
          onClose={() => setOpen(false)}
          appName={appName}
          appKey={appKey}
        />
      )}
    </Container>
  );
}
